<template>
    <li>
        <div :class="labelClass">
            <router-link :to="{ name: 'kategorie-detail', params: {title: cat.title, id: cat.id} }">{{ cat.title }}</router-link>
            <span v-if="cat.children" @click="toggle">[{{ open ? '-' : '+' }}]</span>
        </div>
        <ul v-if="cat.children" v-show="open" class="sub">
            <cat-tree v-for="child in cat.children" :cat="child" :key="child.id" :depth="depth + 1"></cat-tree>
        </ul>
    </li>
</template>

<script>
    export default {
        name: "CatTree",
        props: {
            cat: Object,
            depth: Number
        },
        data() {
            return {
                open: false
            }
        },
        methods: {
            toggle() {
                this.open = !this.open;
            }
        },
        computed: {
            labelClass() {
                return 'label depth-' + this.depth;
            }
        }
    }
</script>

<style scoped>

</style>